export default {
  'complete-order': {
    label: "Ajouter des articles jusqu'à ",
  },
};
